import React from 'react';
import Main from './components/Main.jsx';
import './App.scss';

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
